export default "__VITE_ASSET__S6DDro69__"